import React, { useEffect, useState } from 'react';
import { Form, Button, Input, Row, Col, message, Upload, Select, Switch, Radio, Alert, Tooltip, Image, Popover, DatePicker } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import { motion } from "framer-motion"
import apiClient from 'services/apiClient';
import { useMyContext } from 'Context/MyContextProvider';
import { MessageOutlined, MailOutlined, WhatsAppOutlined, SafetyOutlined, BellOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import { UserSelectField } from '../../CustomUtils.js/CommonFieldUtils';
import { ManageAlertsHeader, CustomAlertBanner, CustomAlertCard } from '../../components/AlertBadge';
import { useMobileHeader } from 'layouts/inner-app-layout';
import CustomDrawer from 'components/shared-components/CustomDrawer';

const { Option } = Select;
const EditProfile = ({ api, authToken, navigate, id }) => {
    const { userRole, Permisson, isMobile } = useMyContext();
    const [alertDrawerVisible, setAlertDrawerVisible] = useState(false);

    useMobileHeader(
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '16px', fontWeight: '700', color: '#1a3353' }}>Edit User</span>
            {isMobile && Permisson?.includes('Update Alerts') && (
                <Button
                    type="text"
                    icon={<BellOutlined style={{ fontSize: '18px', color: '#1a3353' }} />}
                    onClick={() => setAlertDrawerVisible(true)}
                    style={{ padding: 0, height: 'auto', display: 'flex', alignItems: 'center' }}
                />
            )}
        </div>
    );

    const [reportingUser, setReportingUser] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [number, setNumber] = useState('');
    const [loading, setLoading] = useState(true);
    const [roles, setRoles] = useState([]);
    const [role, setRole] = useState('');
    const [roleId, setRoleId] = useState('');
    const [status, setStatus] = useState('');
    const [userBilling, setUserBilling] = useState('');
    const [subscriptionOnboardDate, setSubscriptionOnboardDate] = useState(null);
    const [userDetail, setUserDetail] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [whiteLabelPanel, setWhiteLabelPanel] = useState(false);
    const [whiteLabelLogo, setWhiteLabelLogo] = useState('');
    const [loginBackground, setLoginBackground] = useState('');
    const [termsUrl, setTermsUrl] = useState('');
    const [privacyUrl, setPrivacyUrl] = useState('');
    const [hostUrl, setHostUrl] = useState('');
    const [copyright, setCopyright] = useState({ label: '', link: '' });
    const [error, setError] = useState('');
    const [config, setConfig] = useState([
        {
            title: 'Email Alerts',
            key: 'email_alerts',
            icon: MailOutlined,
            allow: !!(userDetail && userDetail?.email_alert)
        },
        {
            title: 'Whatsapp Alerts',
            key: 'whatsapp_alerts',
            icon: WhatsAppOutlined,
            allow: !!(userDetail && userDetail?.whatsapp_alert)
        },
        {
            title: 'SMS Alerts',
            key: 'text_alerts',
            icon: MessageOutlined,
            allow: !!(userDetail && userDetail?.sms_alert)
        }
    ]);

    useEffect(() => {
        setLoading(true);
        apiClient.get(`${api}edit-user/${id}`, {
            headers: {
                'Authorization': 'Bearer ' + authToken,
            }
        })
            .then(response => {
                const data = response.data.user[0];
                setUserDetail(data)
                setRoleId(data?.role?.id);
                setName(data?.name);
                setCompanyName(data?.company_name);
                setEmail(data?.email);
                setNumber(data?.phone_number);
                setReportingUser(data?.reporting_user?.id);
                setRole(data.role?.name);
                setStatus(data.status);
                setUserBilling(data.user_billing);
                setSubscriptionOnboardDate(
                    data?.subscription_onboard_date
                        ? dayjs(data.subscription_onboard_date)
                        : null
                );
                setConfig([
                    {
                        title: 'Email Alerts',
                        key: 'email_alerts',
                        icon: MailOutlined,
                        allow: !!data?.email_alert
                    },
                    {
                        title: 'Whatsapp Alerts',
                        key: 'whatsapp_alerts',
                        icon: WhatsAppOutlined,
                        allow: !!data?.whatsapp_alert
                    },
                    {
                        title: 'SMS Alerts',
                        key: 'text_alerts',
                        icon: MessageOutlined,
                        allow: !!data?.sms_alert
                    }
                ]);
                setWhiteLabelPanel(parseInt(data?.white_lable) === 1);
                const brandingConfig = data?.branding_configuration || {};
                const copyright = JSON.parse(brandingConfig?.copyright || '{}');
                setWhiteLabelLogo(brandingConfig?.logo || '');
                setLoginBackground(brandingConfig?.login_bg || '');
                setTermsUrl(brandingConfig?.terms || '');
                setPrivacyUrl(brandingConfig?.privacy || '');
                setHostUrl(brandingConfig?.host_url || '');
                setCopyright({
                    label: copyright?.label || '',
                    link: copyright?.link || ''
                });


            })
            .catch(error => {
                console.log(error);
            }).finally(() => {
                setLoading(false);
            })
    }, [api, authToken, id])

    // Roles come from the dedicated endpoint instead of the edit-user payload.
    useEffect(() => {
        apiClient.get(`${api}role-list`, {
            headers: { 'Authorization': 'Bearer ' + authToken },
        })
            .then(response => {
                setRoles(response.data.role || []);
            })
            .catch(error => {
                console.log(error);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    const handleSwitchChange = (key, checked) => {
        const updatedConfig = config.map(item => {
            if (item.key === key) {
                UpdateSetting(key, checked === true)
                return { ...item, allow: checked };
            }
            return item;
        });
        setConfig(updatedConfig);
    };

    const UpdateSetting = async (key, value) => {
        try {
            await apiClient.post(`${api}update-user-alert/${userDetail?.id}`, {
                [key]: value
            },
                {
                    headers: {
                        'Authorization': 'Bearer ' + authToken,
                    }
                });
        } catch (error) {
        }
    }

    const validateLogoBeforeUpload = (file) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                console.log(img.height);
                if (img.height > 80) {
                    message.error('Logo height must not exceed 80px');
                    reject(false);
                } else {
                    resolve(false); // Prevent upload, just validate
                }
            };
            img.onerror = () => {
                message.error('Invalid image file');
                reject(false);
            };
            img.src = URL.createObjectURL(file);
        });
    };

    const handleLogoChange = (info) => {
        // Store the file object directly in state without upload
        if (info.fileList.length > 0) {
            const file = info.fileList[info.fileList.length - 1];
            if (file.status !== 'error') {
                setWhiteLabelLogo(file.originFileObj || file);
            }
        } else {
            setWhiteLabelLogo('');
        }
    };

    const handleLoginBackgroundChange = (info) => {
        // Store the file object directly in state without upload
        if (info.fileList.length > 0) {
            const file = info.fileList[info.fileList.length - 1];
            if (file.status !== 'error') {
                setLoginBackground(file.originFileObj || file);
            }
        } else {
            setLoginBackground('');
        }
    };

    const UpdateUser = async (e) => {
        e.preventDefault();
        // Create FormData to handle file upload
        const formData = new FormData();
        if (reportingUser) {
            formData.append('reportingUser', id);
        }
        formData.append('company_name', companyName);
        formData.append('name', name);
        formData.append('email', email);
        formData.append('number', number);
        formData.append('status', status);
        formData.append('role_name', role);
        formData.append('user_billing', userBilling);
        if (userRole === 'Admin') {
            formData.append(
                'subscription_onboard_date',
                subscriptionOnboardDate ? dayjs(subscriptionOnboardDate).format('YYYY-MM-DD') : ''
            );
        }
        formData.append('white_lable', whiteLabelPanel ? 1 : 0);
        formData.append('terms_url', termsUrl);
        formData.append('privacy_url', privacyUrl);
        formData.append('host_url', hostUrl);
        formData.append('copyright', JSON.stringify(copyright));
        formData.append('role_id', roleId);
        formData.append('white_label_logo', whiteLabelLogo);
        formData.append('login_bg', loginBackground);

        await apiClient.post(`${api}update-user/${id}`, formData, {
            headers: {
                'Authorization': 'Bearer ' + authToken,
                'Content-Type': 'multipart/form-data',
            }
        })
            .then((response) => {
                if (response.data.status) {
                    //navigate('/users')
                    setError()
                    message.success(response.data.message)
                }
            })
            .catch((error) => {
                setError(error.response.data.message);
            });

    }

    const getAlertCardDetails = (item) => {
        switch (item.key) {
            case 'email_alerts':
                return {
                    desc: 'Receive alerts and notifications via email.',
                    detail: email,
                    detailIcon: <MailOutlined style={{ fontSize: '12px', marginRight: '4px', color: '#8c8c8c' }} />
                };
            case 'whatsapp_alerts':
                return {
                    desc: 'Receive alerts and notifications on WhatsApp.',
                    detail: number,
                    detailIcon: <WhatsAppOutlined style={{ fontSize: '12px', marginRight: '4px', color: '#8c8c8c' }} />
                };
            case 'text_alerts':
                return {
                    desc: 'Receive alerts and notifications via SMS.',
                    detail: number,
                    detailIcon: <MessageOutlined style={{ fontSize: '12px', marginRight: '4px', color: '#8c8c8c' }} />
                };
            default:
                return {
                    desc: '',
                    detail: '',
                    detailIcon: null
                };
        }
    };

    const AlertsContent = () => (
        <>
            {!isMobile && (
                <>
                    <ManageAlertsHeader
                        title="Manage Alerts"
                        subtitle="Choose how you want to receive important updates."
                    />

                    <CustomAlertBanner
                        title="Stay updated"
                        subtitle="Get notified instantly via your preferred channels."
                    />
                </>
            )}

            {config.map(item => {
                const cardDetails = getAlertCardDetails(item);
                return (
                    <CustomAlertCard
                        key={item.key}
                        title={item.title}
                        // desc={cardDetails.desc}
                        detail={cardDetails.detail}
                        detailIcon={cardDetails.detailIcon}
                        icon={item.icon}
                        checked={item.allow}
                        onChange={checked => handleSwitchChange(item.key, checked)}
                    />
                );
            })}

            <CustomAlertBanner
                icon={<SafetyOutlined />}
                title="Your preferences are saved automatically."
                subtitle="You can update your alert settings anytime."
            />
        </>
    );

    return (
        <>
            <Row gutter={ROW_GUTTER}>
                <Col xs={24} sm={24} md={24} lg={24} xl={16}>
                    <div>
                        {!loading && (
                            <Form
                                name="basicInformation"
                                layout="vertical"
                                initialValues={
                                    {
                                        'name': name && name,
                                        'email': email && email,
                                        'company_name': companyName && companyName,
                                        'phoneNumber': number && number,
                                        'account_manager': reportingUser && reportingUser,
                                        'account_managers': roleId && roleId,
                                        'terms_url': termsUrl && termsUrl,
                                        'privacy_url': privacyUrl && privacyUrl,
                                        'host_url': hostUrl && hostUrl,
                                        'copyright_label': copyright.label && copyright.label,
                                        'copyright_link': copyright.link && copyright.link,
                                        'role': role && role,
                                        'user_billing': userBilling && userBilling,
                                        'status': status && status,
                                    }
                                }>
                                <Row>
                                    {error &&
                                        <Col xs={24} sm={24} md={24} lg={24}>
                                            <motion.div
                                                initial={{ opacity: 0, marginBottom: 0 }}
                                                animate={{
                                                    opacity: error ? 1 : 0,
                                                    marginBottom: error ? 20 : 0
                                                }}>
                                                <Alert type="error" showIcon message={error}></Alert>
                                            </motion.div>
                                        </Col>
                                    }
                                    <Col xs={24} sm={24} md={24} lg={24}>
                                        <Row gutter={ROW_GUTTER}>
                                            <Col xs={24} sm={24} md={12}>
                                                <Form.Item
                                                    label="Company Name"
                                                    name="company_name"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please enter your company name!',
                                                        },
                                                    ]}
                                                >
                                                    <Input onChange={(e) => setCompanyName(e.target.value)} />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={12}>
                                                <Form.Item
                                                    label="Name"
                                                    name="name"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please input your name!',
                                                        },
                                                    ]}
                                                >
                                                    <Input onChange={(e) => setName(e.target.value)} />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={12}>
                                                <Form.Item
                                                    label="Email"
                                                    name="email"
                                                    rules={[{
                                                        required: true,
                                                        type: 'email',
                                                        message: 'Please enter a valid email!'
                                                    }]}
                                                >
                                                    <Input onChange={(e) => setEmail(e.target.value)} />
                                                </Form.Item>
                                            </Col>
                                            <Col xs={24} sm={24} md={12}>
                                                <Form.Item
                                                    label="Phone Number"
                                                    name="phoneNumber"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: 'Please input your Phone Number!',
                                                        },
                                                    ]}
                                                >
                                                    <Input onChange={(e) => setNumber(e.target.value)} />
                                                </Form.Item>
                                            </Col>
                                            {
                                                userRole === 'Admin' &&
                                                <>
                                                    <Col xs={24} sm={24} md={12}>
                                                        <Form.Item
                                                            label="Account Manager"
                                                            name="account_manager"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please select your Account Manager!',
                                                                },
                                                            ]}
                                                        >
                                                            <UserSelectField
                                                                value={reportingUser}
                                                                HandleUserChange={data => setReportingUser(data)}
                                                            />
                                                        </Form.Item>

                                                    </Col>
                                                    <Col xs={24} sm={24} md={12}>
                                                        <Form.Item
                                                            label="Select Role"
                                                            name="role"
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Please select your Role!',
                                                                },
                                                            ]}
                                                        >

                                                            <Select
                                                                showSearch
                                                                size={'default'}
                                                                defaultValue={role}
                                                                style={{ width: '100%' }}
                                                                onChange={(value) => {
                                                                    setRoleId(value);
                                                                    const selectedRole = roles.find(r => r.id === value);
                                                                    setRole(selectedRole?.name || '');
                                                                }}
                                                                initialValues
                                                            >
                                                                {
                                                                    roles.length > 0 ?
                                                                        roles.map((item, index) =>
                                                                            <Option value={item.id} key={index}>{item.name}</Option>

                                                                        )
                                                                        :
                                                                        <Option value="">No Data Found</Option>
                                                                }
                                                            </Select>
                                                        </Form.Item>

                                                    </Col>
                                                    <Col xs={24} sm={24} md={12}>
                                                        <Form.Item label="User Billing">
                                                            <Radio.Group onChange={(e) => setUserBilling(e.target.value)} value={userBilling}>
                                                                <Radio value='admin'>Admin</Radio>
                                                                <Tooltip title={!reportingUser ? "Please select an Account Manager first" : ""}>
                                                                    <Radio disabled={!reportingUser} value='acount-manager'>Account Manager</Radio>
                                                                </Tooltip>
                                                                <Radio value='self'>Self</Radio>
                                                                {/* <Radio value='verified'>Verified</Radio> */}
                                                            </Radio.Group>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12}>
                                                        <Form.Item label="Onboarding Date">
                                                            <DatePicker
                                                                style={{ width: '100%' }}
                                                                value={subscriptionOnboardDate}
                                                                onChange={(date) => setSubscriptionOnboardDate(date)}
                                                                format="YYYY-MM-DD"
                                                                allowClear
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    {(role?.toLowerCase() === 'reseller' && userRole === 'Admin') && (
                                                        <Col xs={24} sm={24} md={7}>
                                                            <Form.Item label="White Label Panel">
                                                                <Switch
                                                                    checked={whiteLabelPanel}
                                                                    onChange={(checked) => setWhiteLabelPanel(checked)}
                                                                    checkedChildren="Yes"
                                                                    unCheckedChildren="No"
                                                                />
                                                            </Form.Item>
                                                        </Col>
                                                    )}
                                                    <Col xs={24} sm={24} md={role?.toLowerCase() === 'reseller' ? 7 : 14}>
                                                        <Form.Item label="User Status">
                                                            <Radio.Group onChange={(e) => setStatus(e.target.value)} value={status}>
                                                                <Radio value='active'>Active</Radio>
                                                                <Radio value='inactive'>Inactive</Radio>
                                                                {/* <Radio value='verified'>Verified</Radio> */}
                                                            </Radio.Group>
                                                        </Form.Item>
                                                    </Col>
                                                </>
                                            }
                                        </Row>

                                        {/* White Label Panel Settings */}
                                        {role?.toLowerCase() === 'reseller' && whiteLabelPanel && (
                                            <>
                                                {/* Divider */}
                                                <div className="my-4" style={{ borderTop: '1px solid #e8e8e8' }}></div>
                                                <h4 className="mb-3">White Label Panel Settings</h4>
                                                <Row gutter={ROW_GUTTER} className='align-items-center'>
                                                    <Col xs={24} sm={24} md={12}>
                                                        <Form.Item label="Logo" name="logo">
                                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px' }}>
                                                                <div>
                                                                    <Upload
                                                                        listType="picture-card"
                                                                        maxCount={1}
                                                                        beforeUpload={validateLogoBeforeUpload}
                                                                        onChange={handleLogoChange}
                                                                        accept="image/*"
                                                                        onRemove={() => {
                                                                            setWhiteLabelLogo('');
                                                                            return true;
                                                                        }}
                                                                        fileList={whiteLabelLogo ? [{
                                                                            uid: '-1',
                                                                            name: 'logo',
                                                                            status: 'done',
                                                                            url: typeof whiteLabelLogo === 'string'
                                                                                ? whiteLabelLogo
                                                                                : URL.createObjectURL(whiteLabelLogo),
                                                                        }] : []}
                                                                        customRequest={({ onSuccess }) => {
                                                                            // Prevent default upload, just mark as success
                                                                            onSuccess("ok");
                                                                        }}
                                                                    >
                                                                        {!whiteLabelLogo && (
                                                                            <div>
                                                                                <div>+ Upload</div>
                                                                            </div>
                                                                        )}
                                                                    </Upload>
                                                                    <div className="text-muted mt-1" style={{ fontSize: '12px' }}>
                                                                        Maximum height: 80px
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12}>
                                                        <Form.Item
                                                            label={
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                    <span>Login Background</span>
                                                                    <Popover
                                                                        content={
                                                                            <div style={{ textAlign: 'center' }}>
                                                                                <img
                                                                                    src="/img/login_bg_skl.png"
                                                                                    alt="Sample Login Background"
                                                                                    style={{
                                                                                        maxWidth: '450px',
                                                                                        maxHeight: '300px',
                                                                                        borderRadius: '8px',
                                                                                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                                                                                    }}
                                                                                />
                                                                                <div className="mt-2 text-muted" style={{ fontSize: '14px' }}>
                                                                                    Sample Login Background Preview
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        title="Background Preview"
                                                                        trigger="hover"
                                                                        placement="right"
                                                                        overlayStyle={{ maxWidth: '500px' }}
                                                                    >
                                                                        <EyeOutlined
                                                                            style={{
                                                                                color: 'green',
                                                                                cursor: 'pointer',
                                                                                fontSize: '14px'
                                                                            }}
                                                                        />
                                                                    </Popover>
                                                                </div>
                                                            }
                                                            name="login_background"
                                                        >
                                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px' }}>
                                                                <div>
                                                                    <Upload
                                                                        listType="picture-card"
                                                                        maxCount={1}
                                                                        beforeUpload={validateLogoBeforeUpload}
                                                                        onChange={handleLoginBackgroundChange}
                                                                        accept="image/*"
                                                                        onRemove={() => {
                                                                            setLoginBackground('');
                                                                            return true;
                                                                        }}
                                                                        fileList={loginBackground ? [{
                                                                            uid: '-2',
                                                                            name: 'login-background',
                                                                            status: 'done',
                                                                            url: typeof loginBackground === 'string'
                                                                                ? loginBackground
                                                                                : URL.createObjectURL(loginBackground),
                                                                        }] : []}
                                                                        customRequest={({ onSuccess }) => {
                                                                            // Prevent default upload, just mark as success
                                                                            onSuccess("ok");
                                                                        }}
                                                                    >
                                                                        {!loginBackground && (
                                                                            <div>
                                                                                <div>+ Upload</div>
                                                                            </div>
                                                                        )}
                                                                    </Upload>
                                                                    <div className="text-muted mt-1" style={{ fontSize: '12px' }}>
                                                                        Recommended: 1127x907px
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12}>
                                                        <Form.Item
                                                            label={<>Host Url &nbsp;<span className='text-danger' style={{ fontWeight: '500' }}>(Website Address)</span></>}
                                                            name="host_url"
                                                        >
                                                            <Input
                                                                value={hostUrl}
                                                                placeholder="web.smsforyou.biz"
                                                                onChange={(e) => setHostUrl(e.target.value)}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12}>
                                                        <Form.Item
                                                            label="Terms & Conditions URL"
                                                            name="terms_url"
                                                        >
                                                            <Input
                                                                value={termsUrl}
                                                                placeholder="https://example.com/terms"
                                                                onChange={(e) => setTermsUrl(e.target.value)}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12}>
                                                        <Form.Item
                                                            label="Privacy Policy URL"
                                                            name="privacy_url"
                                                        >
                                                            <Input
                                                                value={privacyUrl}
                                                                placeholder="https://example.com/privacy"
                                                                onChange={(e) => setPrivacyUrl(e.target.value)}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12}>
                                                        <Form.Item
                                                            label="Copyright Label"
                                                            name="copyright_label"
                                                        >
                                                            <Input
                                                                value={copyright.label}
                                                                placeholder="e.g., © 2025 Your Company"
                                                                onChange={(e) => setCopyright(prev => ({ ...prev, label: e.target.value }))}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col xs={24} sm={24} md={12}>
                                                        <Form.Item
                                                            label="Copyright Link"
                                                            name="copyright_link"
                                                        >
                                                            <Input
                                                                value={copyright.link}
                                                                placeholder="https://example.com"
                                                                onChange={(e) => setCopyright(prev => ({ ...prev, link: e.target.value }))}
                                                            />
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </>
                                        )}

                                        {/* Divider */}
                                        <div className='d-flex justify-content-end'>
                                            <Button type="primary" className='mr-2' danger onClick={(e) => navigate('/users')}>
                                                Cancel
                                            </Button>
                                            {Permisson?.includes('Update Edit Profile') &&
                                                <Button type="primary" htmlType="submit" onClick={(e) => UpdateUser(e)}>
                                                    Save Change
                                                </Button>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </div>
                </Col>
                {!isMobile && Permisson?.includes('Update Alerts') && (
                    <Col xs={24} sm={24} md={24} lg={24} xl={8}>
                        {!loading && <AlertsContent />}
                    </Col>
                )}
            </Row>

            {isMobile && Permisson?.includes('Update Alerts') && (
                <CustomDrawer
                    title="Manage Alerts"
                    open={alertDrawerVisible}
                    onClose={() => setAlertDrawerVisible(false)}
                >
                    <div style={{ padding: '0px' }}>
                        <AlertsContent />
                    </div>
                </CustomDrawer>
            )}
        </>
    )
}

export default EditProfile